<template>
  <div class="mx-3 py-2">
    <fdw-prop-finder
      client="114"
      league="nba"
      show-headshots="true"
      show-previous-results="true"
      team-id="2:28"
    ></fdw-prop-finder>
  </div>
</template>

<script>
export default {
  name: "NbaPropFinder",
};
</script>

<style lang="scss" scoped></style>
